import { defineComponent as _defineComponent } from 'vue'
import {
  SelectionStep,
  ReviewStep,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary,
  Modal,
  Heading,
  ContextColorProvider,
  LoaderIndicator,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { computed, onMounted, ref } from 'vue';
import {
  getProfitCancelMenu,
  cancelProfit
} from '@/modules/trade/services/profit';
import type { ProfitCancelMenu } from '@/modules/trade/services/profit';
import { useRouter } from 'vue-router/composables';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import { isBFFError } from '@/modules/common/helpers/bff';
import { TextBox } from '@/modules/common/components/TextBox';

enum Steps {
  SELECT_PLAN = 'select-plan',
  CONFIRM = 'confirm',
  SELECT_REASON = 'select-reason',
  DESCRIBE_REASON = 'describe-reason'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfitUnsubscribeView',
  setup(__props) {

const profitCancelMenu = ref<ProfitCancelMenu | null>(null);
const isLoading = ref(false);
const hasError = ref(false);
const profitOptionSelected = ref<string | number>('');
const profitReasonSelected = ref<string | number>('');
const step = ref<Steps | null>(null);
const isModalReasonOpen = ref(false);
const reasonDescription = ref('');
const isLoadingCancelPlan = ref(false);

const router = useRouter();

const mountOptions = computed(() => {
  return profitCancelMenu.value?.cancellation.options.map(option => ({
    title: option.value,
    value: option.id
  }));
});

const mountReasons = computed(() => {
  return profitCancelMenu.value?.reasons.reasonsOptions.map(
    (reason, index) => ({
      title: reason.value,
      value: index
    })
  );
});

const planSelected = computed(() => {
  return profitCancelMenu.value?.cancellation.options.find(
    option => option.id === profitOptionSelected.value
  );
});

const reasonSelected = computed(() => {
  return profitCancelMenu.value?.reasons.reasonsOptions[
    profitReasonSelected.value! as number
  ];
});

const hasMultiplePlans = computed(() => {
  return (
    profitCancelMenu.value?.cancellation &&
    profitCancelMenu.value?.cancellation.options.length > 1
  );
});

const isReasonStep = computed(() => {
  return (
    step.value === Steps.SELECT_REASON || step.value === Steps.DESCRIBE_REASON
  );
});

async function fetchProfitCancelMenu() {
  isLoading.value = true;

  try {
    profitCancelMenu.value = await getProfitCancelMenu();
    setFirstStep();
  } catch (error) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

function handleSelectOption(value: number) {
  profitOptionSelected.value = value;
}

function handleSelectReason(value: number) {
  profitReasonSelected.value = value;
}

function clearInputReason() {
  reasonDescription.value = '';
}

function handleSubmitReason() {
  if (reasonSelected.value?.shouldOpenTextEditor) {
    isModalReasonOpen.value = true;
    setStep(Steps.DESCRIBE_REASON);
  } else {
    proceedUnsubscribe();
  }
}

function backToProfitSubscription() {
  if (step.value === Steps.CONFIRM && hasMultiplePlans.value) {
    setStep(Steps.SELECT_PLAN);
  } else {
    router.push({ name: 'profitSubscription' });
  }
}

async function proceedUnsubscribe() {
  isLoadingCancelPlan.value = true;
  try {
    const cancelPlan = await cancelProfit(
      planSelected.value!.id,
      reasonDescription.value || reasonSelected.value?.value!
    );

    notify({
      group: 'wrn-notifications',
      text: cancelPlan.message,
      type: NotificationTypes.success
    });

    backToProfitSubscription();
  } catch (e) {
    getErrorMessage(e);
  } finally {
    isLoadingCancelPlan.value = false;
  }
}

function setStep(stepToGo: Steps | null) {
  step.value = stepToGo;
}

function closeModalReason() {
  isModalReasonOpen.value = false;
}

function setFirstStep() {
  if (hasMultiplePlans.value) {
    step.value = Steps.SELECT_PLAN;
  } else {
    profitOptionSelected.value =
      profitCancelMenu.value!.cancellation.options[0].id;
    step.value = Steps.CONFIRM;
  }
}

function getErrorMessage(e: unknown) {
  let errorMessage = 'Houve um problema ao cancelar o Profit.';
  console.log(e);
  if (isBFFError(e)) {
    errorMessage = e.error.message.formatted;
  }
  notify({
    group: 'wrn-notifications',
    text: errorMessage,
    type: NotificationTypes.error
  });
}

onMounted(async () => {
  await fetchProfitCancelMenu();
});

return { __sfc: true,Steps, profitCancelMenu, isLoading, hasError, profitOptionSelected, profitReasonSelected, step, isModalReasonOpen, reasonDescription, isLoadingCancelPlan, router, mountOptions, mountReasons, planSelected, reasonSelected, hasMultiplePlans, isReasonStep, fetchProfitCancelMenu, handleSelectOption, handleSelectReason, clearInputReason, handleSubmitReason, backToProfitSubscription, proceedUnsubscribe, setStep, closeModalReason, setFirstStep, getErrorMessage, SelectionStep, ReviewStep, ButtonContainer, ButtonPrimary, ButtonSecondary, Modal, Heading, ContextColorProvider, LoaderIndicator, HelperViewStatus, TextBox }
}

})